import Cookies from 'js-cookie';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

import showModal from '@/utils/show_modal';

const COOKIE_KEY = 'tariff_selection_modal_shown';

$(document).on('turbolinks:load', () => {
  const $modal = $('.b-modal-tariff.is-tariff-selection');
  if (!$modal.length) { return; }
  if (Cookies.get(COOKIE_KEY)) { return; }

  const modal = showModal({
    $modal,
    isHiddenCheck: () => !$modal.hasClass('is-active'),
    show() {
      disablePageScroll();
      $modal.addClass('is-active');
      Cookies.set(COOKIE_KEY, '1', { expires: 1, path: '/' });
    },
    hide() {
      enablePageScroll();
      $modal.removeClass('is-active');
    }
  });

  $modal.find('.modal-shade').on('click', modal.hide);
  $modal.find('.modal-close').on('click', modal.hide);

  modal.show();
});
